import { NSALoginPage } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import "./LoginPage.module.css";

function LoginPage()
{
    return (
        <NSALoginPage
            product_id={ProductUUID.NAMIRASOFT_PAYMENT}
        />
    );
}

export default LoginPage;